module.exports = __webpack_public_path__ + "static/img/logoRH2_solo.9c58b3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/logoRH2_solo.png
// module id = F3FO
// module chunks = 0